import React, { Fragment } from 'react';
import { Modal } from '../../../../../components/migrated/modal';
import { IModalLimiteSize } from './interfaces';
import CancelIcon from '@material-ui/icons/Cancel';
import { useStyles } from './styles';
import { Typography } from '@material-ui/core';

export const ModalLimiteSize = (props: IModalLimiteSize) => {
  const { filesNotSupported, open, handleClose } = props;
  const classes = useStyles();

  return (
    <Modal open={open} onClose={handleClose} title="ADICIONAR ARQUIVOS">
      <div className={classes.root}>
        <CancelIcon />

        <div>
          <Typography>
            Ocorreu um erro no carregamento dos arquivos. Os arquivos abaixo ultrapassam o tamanho permitido e não podem
            ser adicionados.
          </Typography>

          <ul>
            {filesNotSupported.map((notUpload, key) => (
              <Fragment key={key}>
                {!notUpload.fileAllowedSize && (
                  <li>
                    <Typography>{notUpload.fileName}</Typography>
                  </li>
                )}
              </Fragment>
            ))}
          </ul>

          <Typography>Selecione arquivos com tamanho de até 5MB.</Typography>
        </div>
      </div>
    </Modal>
  );
};
